/**
 * Every help article title, keyed by bookmark, in one place.
 * Titles are plain strings so they can be reviewed and re-cased without touching an article body.
 */
export const HELP_TITLES = {
    'where-is-the-cart': 'Where is the cart?',
    'where-do-i-start': 'Where do I start?',
    'how-do-i-search': 'How do I search?',
    'no-results-found': 'Why does it say no results were found?',
    'how-do-i-know-correct-item': 'How do I know I\'m paying for the correct thing?',
    'what-is-item-details': 'What is the item details page?',
    'where-are-payment-options': 'What are payment options?',
    'cart-warning': 'What is this warning?',
    'zip-code-does-not-match': 'Why do I keep getting "Zip code does not match billing address"?',
    'credit-card-rejected': 'Why is my credit card being rejected?',
    'how-do-i-create-account': 'How do I sign up?',
    'manage-account': 'How can I manage my profile?',
    'how-remove-item-from-cart': 'How do I remove something from my cart?',
    'how-do-i-pay': 'How do I pay?',
    'what-are-saved-payment-methods': 'What are saved payment methods?',
    'how-to-add-saved-payment-method': 'How do I add a saved payment method?',
    'how-to-update-saved-payment-method': 'How do I update a saved payment method?',
    'view-previous-payments': 'How can I view receipts from previous payments?',
    'forgot-password': 'What do I do if I forgot my password?',
    'verification-code-not-working': 'Why is my verification code not working?',
    'how-to-pay-for-multiple-items': 'How do I pay for multiple properties in one transaction?',
    'what-are-linked-accounts': 'What are |term:plural|?',
    'how-do-i-add-a-linked-account': 'How do I add |term:plural|?',
    'linked-account-nickname': 'What is a nickname and how do I change it?',
    'linked-account-balance-status':
        'What do the balance, status and open items on |term:plural| mean?',
    'how-do-i-refresh-a-linked-account': 'How do I refresh the balance on my |term:plural|?',
    'how-do-i-pay-a-linked-account': 'How do I pay |term:plural|?',
    'how-many-linked-accounts': 'How many |term:plural| can I have, and how do I remove one?',
    'linked-account-unavailable':
        'Why does one of my |term:plural| say "No longer available online"?'
} as const satisfies Record<string, string>;

export type HelpTitleKey = keyof typeof HELP_TITLES;

/** The title for a bookmark. Typed by key, so a typo or a removed bookmark fails to compile. */
export function helpTitle(bookmark: HelpTitleKey): string {
    return HELP_TITLES[bookmark];
}
